<template>
  <div v-if="isLoading" class="loader-overlay">
    <div class="loader"></div>
  </div>

  <Navbar dir="rtl" />
  <main dir="rtl" class="main" :class="mainClass">
    <slot />
    <Footer />
  </main>

  <VerifyUpdateProfileModal dir="rtl" />
  <VerifyNewMobileModal dir="rtl" />
  <VerifyNewNameModal dir="rtl" />
  <WarningModal dir="rtl" />
  <LoginModal dir="rtl" />
  <GlobalAlert />
</template>

<script setup>
// Other imports and logic, such as router hooks, Fancybox binding, etc.
import Navbar from "@/layouts/components/Navbar.vue";
import Footer from "@/layouts/components/Footer.vue";
import LoginModal from "@/components/LoginModal.vue";
import VerifyUpdateProfileModal from "@/components/VerifyUpdateProfileModal.vue";
import VerifyNewMobileModal from "@/components/VerifyNewMobileModal.vue";
import VerifyNewNameModal from "@/components/VerifyNewNameModal.vue";
import WarningModal from "@/components/warningModal.vue";
import GlobalAlert from "@/components/GlobalAlert.vue";

import { ref, onMounted, nextTick } from "vue";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const { coordinates , fetchLocation } = useGeolocation();

// Using a hypothetical store and geolocation hook
import { useWebsiteStore } from '~/store/website';
const websiteStore = useWebsiteStore();

import { useRouter } from 'vue-router';
const router = useRouter();

const isLoading = ref(false);

// Simulate route hooks
router.beforeEach(() => {
    isLoading.value = false;
});
router.afterEach(() => {
    isLoading.value = false;
});

import { useHead } from '#imports'


// setTimeout(() => {
// }, 1500); //


const config = useRuntimeConfig()

// Retrieve public runtime config
const env  =  config.public.env || 'development';


// Apply head configuration only in production
if (env === 'production') {
  useHead({
    meta: [
      {
        name: 'google-site-verification',
        content: 'dB1c6V29-MhkZ44eGdY_BdsgPKTUQ66L0u-EKhsbA9I'
      }
    ],
    script: [
      {
        src: 'https://www.googletagmanager.com/gtag/js?id=G-BHZ6CLK3MH',
        async: true
      },
      {
        // Initialization code for gtag
        children: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-BHZ6CLK3MH');
        `,
        type: 'text/javascript'
      },
      {
        // Initialization code for gtag
        children: `
         window.smartlook||(function(d) {
         var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
         var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
         c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
         })(document);
         smartlook('init', '2f865850d7fcc792bc7cadf5c8f10085b1f94f36', { region: 'eu' });
        `,
        type: 'text/javascript'
      },
    ],
    noscript: [
      {
        // Including noscript tag in the body
        children: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PPVC45DG" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        body: true
      }
    ]
  });
}

defineProps({
  mainClass: {
    type: String,
    default: "",
  },
});

onMounted(() => {

   setTimeout(() => {
    fetchLocation();
   }, 2000);
    setTimeout(() => {
        isLoading.value = false;
    }, 1500);
    nextTick(() => {
        Fancybox.bind("[data-fancybox]", {
            Hash: false,
            Panzoom: {
                zoom: false
            },
            Thumbs: {
                autoStart: true,
            }
        });
    });
});
</script>

<style scoped>
.loader-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.loader {
    width: 50px;
    height: 50px;
    border: 5px solid #3498db;
    border-top: 5px solid transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
